module.exports = __webpack_public_path__ + "img/fangpian.07699d6c.jpg";